// extracted by mini-css-extract-plugin
export default {"root":"ImageViewer_root__dXIqf","image":"ImageViewer_image__2P0+A"};